/* =========================================================
   SCENTOM Premium Product Page — Shared Behaviour
   ========================================================= */
(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.ppr-reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initDragScroll(selector) {
    document.querySelectorAll(selector).forEach(function (track) {
      var isDown = false, startX, scrollLeft;
      track.addEventListener('mousedown', function (e) {
        isDown = true;
        track.classList.add('is-dragging');
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
      });
      ['mouseleave', 'mouseup'].forEach(function (evt) {
        track.addEventListener(evt, function () { isDown = false; track.classList.remove('is-dragging'); });
      });
      track.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - track.offsetLeft;
        track.scrollLeft = scrollLeft - (x - startX) * 1.4;
      });
    });
  }

  function PremiumProductForm(root) {
    this.root = root;
    this.sectionId = root.dataset.sectionId;
    this.productHandle = root.dataset.productHandle;
    this.variants = JSON.parse(root.querySelector('[data-variant-json]').textContent);
    this.form = root.querySelector('form[data-product-form]');
    this.qtyInput = root.querySelector('[data-qty-input]');
    this.gallery = root.querySelector('[data-gallery]');
    this.mainImgWrap = root.querySelector('[data-gallery-main]');
    this.thumbs = root.querySelectorAll('[data-thumb]');
    this.slides = root.querySelectorAll('[data-slide]');
    this.currentSlide = 0;
    this.plans = root.querySelectorAll('[data-plan]');
    this.optionButtons = root.querySelectorAll('[data-option-value]');
    this.priceNow = root.querySelector('[data-price-now]');
    this.priceWas = root.querySelector('[data-price-was]');
    this.priceSave = root.querySelector('[data-price-save]');
    this.stickyBar = document.querySelector('[data-sticky-bar="' + this.sectionId + '"]');
    this.addBtn = root.querySelector('[data-add-to-cart]');
    this.selectedOptions = {};

    this.init();
  }

  PremiumProductForm.prototype.init = function () {
    this.bindGallery();
    this.bindQty();
    this.bindPlans();
    this.bindOptions();
    this.bindAccordion();
    this.bindForm();
    this.bindStickyBar();
  };

  PremiumProductForm.prototype.bindGallery = function () {
    var self = this;
    if (self.thumbs.length) {
      self.thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { self.goToSlide(i); });
      });
    }
    var prev = self.root.querySelector('[data-gallery-prev]');
    var next = self.root.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { self.goToSlide(self.currentSlide - 1); });
    if (next) next.addEventListener('click', function () { self.goToSlide(self.currentSlide + 1); });

    if (self.mainImgWrap) {
      var startX = 0;
      self.mainImgWrap.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      self.mainImgWrap.addEventListener('touchend', function (e) {
        var diff = e.changedTouches[0].clientX - startX;
        if (Math.abs(diff) > 40) self.goToSlide(self.currentSlide + (diff < 0 ? 1 : -1));
      }, { passive: true });
    }
  };

  PremiumProductForm.prototype.goToSlide = function (index) {
    var total = this.slides.length;
    if (!total) return;
    var i = ((index % total) + total) % total;
    this.slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
    this.thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
    this.currentSlide = i;
    var vid = this.slides[i].querySelector('video');
    this.root.querySelectorAll('video').forEach(function (v) { if (v !== vid) v.pause(); });
  };

  PremiumProductForm.prototype.bindQty = function () {
    var self = this;
    var minus = self.root.querySelector('[data-qty-minus]');
    var plus = self.root.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      var v = Math.max(1, parseInt(self.qtyInput.value || '1', 10) - 1);
      self.qtyInput.value = v;
    });
    if (plus) plus.addEventListener('click', function () {
      var v = parseInt(self.qtyInput.value || '1', 10) + 1;
      self.qtyInput.value = v;
    });
  };

  PremiumProductForm.prototype.bindPlans = function () {
    var self = this;
    if (!self.plans.length) return;
    self.plans.forEach(function (plan) {
      plan.addEventListener('click', function () {
        self.plans.forEach(function (p) { p.classList.remove('is-active'); });
        plan.classList.add('is-active');
        var qty = parseInt(plan.dataset.qty || '1', 10);
        if (self.qtyInput) self.qtyInput.value = qty;
        self.updatePriceFromPlan(plan);
      });
    });
    var active = self.root.querySelector('[data-plan].is-active') || self.plans[0];
    if (active) active.click();
  };

  PremiumProductForm.prototype.updatePriceFromPlan = function (plan) {
    if (this.priceNow && plan.dataset.priceNow) this.priceNow.textContent = plan.dataset.priceNow;
    if (this.priceWas) {
      if (plan.dataset.priceWas) { this.priceWas.textContent = plan.dataset.priceWas; this.priceWas.style.display = ''; }
      else { this.priceWas.style.display = 'none'; }
    }
    if (this.priceSave) {
      if (plan.dataset.priceSave) { this.priceSave.textContent = plan.dataset.priceSave; this.priceSave.style.display = ''; }
      else { this.priceSave.style.display = 'none'; }
    }
  };

  PremiumProductForm.prototype.bindOptions = function () {
    var self = this;
    if (!self.optionButtons.length) return;
    self.optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.hasAttribute('disabled')) return;
        var name = btn.dataset.optionName;
        var value = btn.dataset.optionValue;
        self.selectedOptions[name] = value;
        self.root.querySelectorAll('[data-option-name="' + name + '"]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        self.syncVariant();
      });
    });
    self.optionButtons.forEach(function (btn) {
      if (btn.classList.contains('is-active')) self.selectedOptions[btn.dataset.optionName] = btn.dataset.optionValue;
    });
  };

  PremiumProductForm.prototype.syncVariant = function () {
    var self = this;
    var match = self.variants.find(function (v) {
      return v.options.every(function (optVal, idx) {
        var name = self.optionNames[idx];
        return self.selectedOptions[name] === undefined || self.selectedOptions[name] === optVal;
      });
    });
    if (!match) return;
    var input = self.form.querySelector('[name="id"]');
    if (input) input.value = match.id;
    if (self.priceNow) self.priceNow.textContent = self.formatMoney(match.price);
    if (self.priceWas) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        self.priceWas.textContent = self.formatMoney(match.compare_at_price);
        self.priceWas.style.display = '';
      } else {
        self.priceWas.style.display = 'none';
      }
    }
    if (self.addBtn) {
      if (match.available) {
        self.addBtn.removeAttribute('disabled');
        self.addBtn.textContent = self.addBtn.dataset.labelAvailable || 'Add to Cart';
      } else {
        self.addBtn.setAttribute('disabled', 'disabled');
        self.addBtn.textContent = self.addBtn.dataset.labelSoldOut || 'Sold Out';
      }
    }
    if (self.stickyBar) {
      var sp = self.stickyBar.querySelector('[data-sticky-price]');
      if (sp) sp.textContent = self.formatMoney(match.price);
    }
  };

  PremiumProductForm.prototype.formatMoney = function (cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PKR' });
  };

  PremiumProductForm.prototype.bindAccordion = function () {
    this.root.querySelectorAll('[data-acc-item]').forEach(function (item) {
      var trigger = item.querySelector('[data-acc-trigger]');
      var panel = item.querySelector('[data-acc-panel]');
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        item.parentElement.querySelectorAll('[data-acc-item]').forEach(function (other) {
          other.classList.remove('is-open');
          other.querySelector('[data-acc-panel]').style.maxHeight = null;
        });
        if (!isOpen) {
          item.classList.add('is-open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  };

  PremiumProductForm.prototype.bindForm = function () {
    var self = this;
    if (!self.form) return;
    self.form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (self.addBtn && self.addBtn.hasAttribute('disabled')) return;
      var formData = new FormData(self.form);
      if (self.qtyInput) formData.set('quantity', self.qtyInput.value || '1');
      var originalText = self.addBtn ? self.addBtn.textContent : '';
      if (self.addBtn) { self.addBtn.textContent = 'Adding…'; self.addBtn.setAttribute('disabled', 'disabled'); }

      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (self.addBtn) { self.addBtn.textContent = 'Added ✓'; }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () {
            if (self.addBtn) { self.addBtn.textContent = originalText; self.addBtn.removeAttribute('disabled'); }
          }, 1800);
        })
        .catch(function () {
          if (self.addBtn) { self.addBtn.textContent = 'Try Again'; self.addBtn.removeAttribute('disabled'); }
        });
    });
  };

  PremiumProductForm.prototype.bindStickyBar = function () {
    var self = this;
    if (!self.stickyBar) return;
    var trigger = self.root.querySelector('[data-add-to-cart]');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        self.stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    if (trigger) observer.observe(trigger);
    var stickyBtn = self.stickyBar.querySelector('[data-sticky-add]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      if (self.form) self.form.requestSubmit ? self.form.requestSubmit() : self.form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initDragScroll('[data-drag-scroll]');
    document.querySelectorAll('[data-premium-product-form]').forEach(function (root) {
      var variants = root.querySelector('[data-variant-json]');
      if (!variants) return;
      var instance = new PremiumProductForm(root);
      var optionNamesEl = root.querySelector('[data-option-names]');
      instance.optionNames = optionNamesEl ? JSON.parse(optionNamesEl.textContent) : [];
      root.pprInstance = instance;
    });

    document.querySelectorAll('[data-testi-dots]').forEach(function (dotsWrap) {
      var track = document.querySelector('[data-testi-track="' + dotsWrap.dataset.testiDots + '"]');
      if (!track) return;
      var dots = dotsWrap.querySelectorAll('[data-testi-dot]');
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var card = track.children[i];
          if (card) track.scrollTo({ left: card.offsetLeft - 24, behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', function () {
        var idx = Math.round(track.scrollLeft / (track.children[0] ? track.children[0].offsetWidth + 24 : 1));
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      });
    });
  });
})();
